import styled from "styled-components";

export const BetaText = styled.div`
  display: inline-flex;
  align-items: center;
  position: fixed;
  left: 0.75rem;
  bottom: 0.75rem;
  z-index: 10000;
  @media print {
    display: none;
  }
`;
